<template>
  <div>
    <div class="title">
      {{ _[conflicts.model] }} ID: {{ conflicts.id }}
      <span @click="closeModal()"><font-awesome-icon :icon="['fas', 'times']" /></span>
    </div>
    <div class="content">
      <component :is="conflicts.type.split('_').map((piece) => piece[0].toUpperCase() + piece.slice(1)).join('')" :id="conflicts.id" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SessionOverlappings from '@/components/conflicts/SessionOverlappings'
import SessionPersonOverlappings from '@/components/conflicts/SessionPersonOverlappings'
import PersonOverlappings from '@/components/conflicts/PersonOverlappings'
export default {
  components: {
    SessionOverlappings,
    SessionPersonOverlappings,
    PersonOverlappings,
  },
  computed: {
    ...mapGetters(['conflicts']),
  },
  methods: {
    ...mapMutations(['closeModal']),
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.modal {
  > div {
    > div {
      display: grid;
      grid-template-rows: 40px 1fr;
      grid-template-columns: 1fr;
      height: 100%;
      > .title {
        grid-area: 1/1/2/2;
        background: $primary-color;
        color: #ffffff;
        padding: 12px;
        font-weight: bold;
        > span {
          float: right;
          margin-right: 4px;
          opacity: .4;
          &:hover {
            opacity: 1;
          }
        }
        .svg-inline--fa {
          cursor: pointer;
        }
      }
      > .content {
        grid-area: 2/1/3/2;
        background: #ffffff;
        overflow-y: scroll;
        position: relative;
        > div {
          &.confirm {
            background: lighten($error-color, 70%);
            color: $error-color;
            border-bottom: 1px solid lighten($error-color, 60%);
            line-height: 28px;
            padding: 12px;
            > .control {
              float: right;
              .button {
                padding: 8px 12px;
                cursor: pointer;
                font-weight: bold;
                &.delete {
                  border-radius: 4px 0 0 4px;
                  border: 1px solid $error-color;
                  background: $error-color;
                  color: #ffffff;
                }
                &.cancel {
                  border-radius: 0 4px 4px 0;
                  border: 1px solid lighten($error-color, 60%);
                }
              }
            }
          }
          > div {
            position: relative;
          }
        }
      }
    }
  }
}

</style>